module.exports = __webpack_public_path__ + "img/png.832ce32c.svg";